import { Button, IconButton, Tooltip } from "@mui/material";
import { BorderedOutlineRowDirectionFlex } from "./Containers";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState } from "react";

const truncateToChars = (str = '', len) => {
    if (str.length <= len || str.length - 3 <= 6) {
        return str;
    }

    return str.substring(0, len - 3) + '...';
}

export default function Chip({ label, onDeleteHandler, onSelectHandler }) {

    const [trimmedLabel] = useState(() => truncateToChars(label, 10));

    return (
        <BorderedOutlineRowDirectionFlex>
            {trimmedLabel.length < label.length ? <Tooltip title={label}>
                <Button onClick={onSelectHandler} variant="text-button" size="small">
                    {trimmedLabel}
                </Button>
            </Tooltip> : <Button onClick={onSelectHandler} variant="text-button" size="small">
                {trimmedLabel}
            </Button>}
            <IconButton onClick={onDeleteHandler} size="small">
                <HighlightOffIcon fontSize="small" />
            </IconButton>
        </BorderedOutlineRowDirectionFlex>
    );
}